import React, { memo } from "react";

import { openChat } from "../../../../utils/providers";
import { ReactComponent as SelectedIcon } from "../../../../assets/images/SelectedIcon.svg";
import { ReactComponent as ChatIcon } from "../../../../assets/images/ChatIcon.svg";

import { Container, StyledLink, Text, Wrapper } from "./styles";

const FooterNotification = ({ faqLink }) => {
  const showChat = async () => {
    openChat();
  };

  return (
    <Container>
      {faqLink && (
        <Wrapper>
          <SelectedIcon />
          <Text>
            Find out
            <StyledLink href={faqLink} target="_blank">
              more information
            </StyledLink>
            about this error
          </Text>
        </Wrapper>
      )}
      <Wrapper>
        <ChatIcon />
        <Text>
          <StyledLink onClick={showChat} target="_blank">
            Click here
          </StyledLink>
          to start chat with our Experts
        </Text>
      </Wrapper>
    </Container>
  );
};

export default memo(FooterNotification);
